<script setup lang="ts">
import { gwtBridge } from '@/GWTBridge';
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const loadScreen = () => {
    gwtBridge.then((bridge) => {
        bridge.loadScreen(window.location.hash.substring(1))
    })
}

onMounted(() => {
  loadScreen()
})

watch(() => route.hash, () => {
  loadScreen()
})
</script>
<template></template>